/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_General_Is_Ctitoolbar_EnabledInputs */

const en_forms_teams_settings_general_is_ctitoolbar_enabled = /** @type {(inputs: Forms_Teams_Settings_General_Is_Ctitoolbar_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CTI-Toolbar Enabled`)
};

const de_forms_teams_settings_general_is_ctitoolbar_enabled = /** @type {(inputs: Forms_Teams_Settings_General_Is_Ctitoolbar_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CTI-Toolbar aktiviert`)
};

/**
* | output |
* | --- |
* | "CTI-Toolbar Enabled" |
*
* @param {Forms_Teams_Settings_General_Is_Ctitoolbar_EnabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_general_is_ctitoolbar_enabled = /** @type {((inputs?: Forms_Teams_Settings_General_Is_Ctitoolbar_EnabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_General_Is_Ctitoolbar_EnabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_general_is_ctitoolbar_enabled(inputs)
	return de_forms_teams_settings_general_is_ctitoolbar_enabled(inputs)
});